import type { Dict } from './index';

// Rusça sözlük — Claude tarafından elle çevrildi (06.08.2026), makine
// çevirisi kullanılmadı. en.ts ile aynı yapıda olmalı (tip zorunlu kılar).
export const ru: Dict = {
  signInMethods: {
    // D-871 — the linked Google accounts, and removing one.
    googleAccountUnknown: "Аккаунт Google (адрес пока неизвестен)",
    googleLinkedDate: "Привязан {date}",
    googleRemove: "Удалить",
    googleRemoveTitle: "Удалить этот аккаунт Google?",
    googleRemoveBody: "Сначала ты подтвердишь зарегистрированный номер. После этого с этим аккаунтом Google больше нельзя будет войти в nosubject.",
    googleRemoveConfirm: "Введи код, чтобы удалить {account}.",
    googleRemoved: "Аккаунт Google удалён.",
    googleLastMethod: "Это единственный способ войти в этот аккаунт, поэтому его нельзя удалить.",
    googleAddAnother: "Привязать ещё один аккаунт Google",
    googleLinkedCount: "Привязано аккаунтов Google: {count}",
    googleLinked: "Аккаунт Google привязан.",
    googleCodeSent: "Код отправлен на зарегистрированный номер, оканчивающийся на {phone}.",
    googleChooseHint: "Выбранный аккаунт Google будет привязан для входа в этот аккаунт nosubject.",
    googleStatusUnknown: "Не удалось проверить подключение Google. Повтори проверку.",
    googleLinkIntro: "Подтверди зарегистрированный в этом аккаунте номер телефона, прежде чем привязать Google.",
    googleLinkFailed: "Не удалось выполнить запрос. Попробуй ещё раз.",
    googleSendCode: "Отправить код подтверждения",
    googleCodeLabel: "Код подтверждения",
    googleStartAgain: "Начать заново",
    googleContinue: "Продолжить с Google",
    googleFailed: "Не удалось завершить вход через Google. Попробуй ещё раз.",
    googleNotLinked: "Этот аккаунт Google пока не связан с аккаунтом nosubject.",
    googleUnavailable: "Вход через Google пока недоступен.",
    title: "Способы входа",
    intro: "Этот раздел готовится. Возможность управлять способами входа появится позже.",
    identity: "Подтверждение личности",
    identityInfo: "Подтверждение личности — отдельная процедура, не связанная со входом в аккаунт.",
  },
  safety: {
    title: 'Код безопасности',
    compare: 'Сравни этот код с {name}. Если он совпадает, никто посередине не сможет прочитать переписку.',
    explainInfo: 'Код вычисляется из ключей шифрования всех текущих устройств обоих собеседников и одинаков на обоих телефонах. Если кто-то из двоих добавит устройство, например новый телефон или веб, код изменится. Тогда сравни его снова. Подтверждение хранится только на этом устройстве.',
    qrLabel: 'QR-код кода безопасности',
    verified: 'Подтверждено',
    notVerified: 'Не подтверждено',
    markVerified: 'Отметить как подтверждённый',
    clearVerified: 'Снять подтверждение',
    peerUnavailable: 'Шифрование с этим человеком ещё не включено.',
    selfUnavailable: 'Ключ шифрования этого устройства ещё не готов.',
    loadFailed: 'Не удалось загрузить код безопасности.',
  },
  backup: {
    title: 'Резервная копия чатов',
    explainInfo: 'История хранится на этом устройстве. Копия шифруется твоим кодом восстановления и лежит на сервере; мы её открыть не можем.',
    create: 'Создать копию',
    refresh: 'Обновить копию',
    codeTitle: 'Твой код восстановления',
    codeWarning: 'Сохрани этот код в надёжном месте. Потеряешь — история не вернётся, и мы её тоже не откроем.',
    restoreTitle: 'Восстановить историю',
    restorePlaceholder: 'Код восстановления',
    restore: 'Восстановить',
    restored: 'Восстановлено сообщений: {count}.',
    restoreFailed: 'Не удалось открыть историю. Проверь код.',
    failed: 'Не удалось создать копию.',
  },
  common: {
    clear: "Очистить поиск",
    infoHide: 'Скрыть пояснение: {subject}',
    infoShow: 'Показать пояснение: {subject}',
    continue: 'Продолжить',
    cancel: 'Отмена',
    close: 'Закрыть',
    save: 'Сохранить',
    done: 'Готово',
    retry: 'Повторить',
    error: 'Ошибка',
    back: 'Назад',
    search: 'Поиск…',
    loading: 'Загрузка',
    remove: 'Удалить',
    offline: 'Сервер недоступен. Проверь соединение.',
    sessionExpired: 'Сессия завершилась. Войди снова.',
    tooManyRequests: 'Слишком много запросов. Подожди немного и попробуй снова.',
  },
  time: {
    now: 'сейчас',
    minAgo: '{n} мин назад',
    hourAgo: '{n} ч назад',
    yesterday: 'вчера',
    dayAgo: '{n} дн назад',
    weekAgo: '{n} нед назад',
    weekAgoOne: '{n} нед назад',
    today: 'Сегодня',
    dayYesterday: 'Вчера',
  },
  phone: {
    sendFailed: "Не удалось отправить код. Попробуй ещё раз.",
    subtitle: 'Введи номер телефона',
    selectCountry: 'Страна / регион',
    countrySearch: 'Поиск страны…',
    architectureLink: 'Техническая архитектура и план развития ↗',

  },
  otp: {
    verifyFailed: "Не удалось проверить код. Попробуй ещё раз.",
    invalidCode: "Код недействителен или срок его действия истёк.",
    rateLimited: "Слишком много попыток. Попробуй позже.",
    title: 'Введи код',
    sentTo: 'Мы отправили SMS на {phone}',
    verify: 'Подтвердить',
    resend: 'Отправить снова',

    tooManyAttempts: 'Слишком много попыток. Подожди немного и попробуй снова.',

    resendSent: 'Новый код отправлен.',
    resendFailed: 'Не удалось отправить код. Проверь соединение и попробуй снова.',
    resendWait: 'Можно запросить снова через {n} с',
  },
  university: {
    title: 'В каком университете ты учишься?',
    subtitle: 'Найди через поиск',
    placeholder: 'Гарвард, Оксфорд…',
    skip: 'Пропустить',
  },
  profession: {
    title: 'Кем ты работаешь?',
    subtitle: 'Найди свою профессию',
    placeholder: 'Учитель, разработчик, медсестра…',
    skip: 'Пропустить',
  },
  isco: {
    '0': 'Вооружённые силы',
    '1': 'Руководители',
    '2': 'Специалисты высшего уровня квалификации',
    '3': 'Специалисты среднего уровня квалификации',
    '4': 'Служащие, занятые подготовкой информации',
    '5': 'Работники сферы обслуживания и торговли',
    '6': 'Квалифицированные работники сельского, лесного хозяйства и рыболовства',
    '7': 'Квалифицированные рабочие и ремесленники',
    '8': 'Операторы и сборщики оборудования и машин',
    '9': 'Неквалифицированные рабочие',
  },
  isced: {
    '5': 'Колледж',
    '6': 'Бакалавр',
    '7': 'Магистр',
    '8': 'Доктор наук',
  },
  profileCreate: {
    photoPickerFailed: "Не удалось открыть библиотеку фотографий.",
    title: 'Создай профиль',
    addPhoto: 'Добавить фото',
    name: 'Твоё имя',
    surname: 'Твоя фамилия',
  },
  terms: {
    title: 'Прежде чем начать',
    age: 'Мне больше 18 лет',
    accept: 'Я прочитал(а) и принимаю Условия использования и Политику конфиденциальности',
    termsLink: 'Условия использования',
    privacyLink: 'Политика конфиденциальности',
    continue: 'Принять и продолжить',
    saveFailed: 'Не удалось сохранить согласие. Проверь соединение и попробуй снова.',
    docPlaceholder: 'Этот документ скоро будет опубликован.',
  },
  locationConsent: {
    title: 'Геопозиция — только с твоего разрешения',
    body: 'Чтобы предлагать район и город после съёмки фотографии, нам нужен доступ к геопозиции.',
    privacy: 'На этом шаге геопозиция не считывается. Она используется только после успешной съёмки, а точные координаты не сохраняются. Позже разрешение можно изменить в настройках устройства.',
    allow: 'Разрешить доступ',
    later: 'Не сейчас',
  },
  discover: {
    title: "Обзор",
    categories: "Категории профессий",
    categoryHint: "Находите людей по профессиям, указанным в их профилях.",
    all: "Все",
    reset: "Сбросить фильтры",
    failed: 'Не удалось загрузить',
    free: 'Бесплатно',
    empty: 'Пока здесь никого нет',
  },
  userProfile: {
    smsVerifiedOn: "Телефон подтверждён по SMS · {date}",
    googleLinkedOn: "Аккаунт Google привязан · {date}",
    contactProofNote: "Подтверждает доступ к телефону или аккаунту Google, а не личность человека.",
    failed: 'Не удалось загрузить профиль',
    sendMessage: 'Отправить сообщение',
    buyTime: 'Предложить встречу',
    block: 'Заблокировать',
    blockedNotice: '{name} заблокирован. Сообщения, звонки и встречи отключены.',
    blockTitle: 'Заблокировать {name}?',
    blockMessage: 'Этот человек не сможет писать тебе или найти тебя в поиске.',
    blockConfirm: 'Заблокировать',
  },
  callHistory: {
    empty: 'Пока нет звонков',
    tabAll: 'Все',
    tabMissed: 'Пропущенные',
    emptyMissed: 'Пропущенных звонков нет',
    failed: 'Не удалось загрузить звонки',
    outgoing: 'Исходящий',
    incoming: 'Входящий',
    missed: 'Пропущенный',
    declined: 'Отклонён',
    cancelled: 'Отменён',
  },
  call: {
    title: 'Голосовой звонок',
    calling: 'Вызов…',
    incoming: 'Входящий звонок',
    connecting: 'Подключение…',
    connected: 'Соединено',
    reconnecting: 'Переподключение…',
    logAnswered: 'Голосовой звонок',
    logAnsweredVideo: 'Видеозвонок',
    logNoAnswer: 'Нет ответа',
    logMissed: 'Пропущенный звонок',
    logDeclined: 'Звонок отклонён',
    logYouDeclined: 'Звонок отклонён тобой',
    logCancelled: 'Звонок отменён',
    ended: 'Звонок завершён',
    accept: 'Ответить',
    decline: 'Отклонить',
    hangUp: 'Завершить',
    close: 'Закрыть',
    mute: 'Выключить микрофон',
    unmute: 'Включить микрофон',
    cameraOff: 'Выключить камеру',
    cameraOn: 'Включить камеру',
    flipCamera: 'Сменить камеру',
    audioOutput: 'Аудиовыход: {route}',
    audioOutputTitle: 'Выбери аудиовыход',
    earpiece: 'Динамик телефона',
    speaker: 'Громкая связь',
    bluetooth: 'Bluetooth',
    bluetoothPermissionDenied: 'Доступ к Bluetooth отключён. Включи его в настройках.',
    micPermission: 'Для звонков нужен доступ к микрофону. Включи его в настройках.',
    micPermissionWeb: 'Для звонков нужен доступ к микрофону. Разреши его в настройках сайта в браузере.',
    wiredHeadset: 'Проводная гарнитура',
    audioRouteFailed: 'Не удалось изменить аудиовыход',
    acceptFailed: 'Не удалось ответить на звонок. Попробуй ещё раз.',
    declineFailed: 'Не удалось отклонить звонок. Попробуй ещё раз.',
    endFailed: 'Не удалось завершить звонок. Попробуй ещё раз.',
    mediaConnectionFailed: 'Не удалось установить аудиосоединение. Плата за звонок не взималась.',
    remaining: 'Осталось {time}',
    endingSoon: 'Этот звонок скоро завершится.',
    spent: 'Потрачено {amount}',
    earned: 'Заработано {amount}',
    noAudioNotice: 'В этой версии звук пока не передаётся. Сценарий звонка и оплата тестируются.',
    failed: 'Не удалось начать звонок',
    insufficient: 'Недостаточно средств для этого звонка',
    busy: 'Собеседник сейчас на другом звонке',
    notAllowed: 'Позвонить можно, если в переписке с этим человеком есть хотя бы одно сообщение',
    notAccepting: 'Этот человек сейчас не принимает звонки',
    priceFree: 'Бесплатно',
    priceChanged: 'Тариф звонка изменился. Посмотри новый тариф и попробуй снова.',
    rateLimited: 'Слишком много попыток звонка. Немного подожди и попробуй снова.',
    reservationLinkUnavailable: 'Эту бронь больше нельзя связать со звонком. Вместо этого можно начать обычный звонок.',
    missed: 'Пропущенный звонок',
    callNow: 'Позвонить сейчас',
    videoNow: 'Видеозвонок сейчас',
    scheduledStartTitle: 'Запланированный звонок',
    scheduledStartBody: 'Запланированный звонок с {name} начинается. Позвонить сейчас?',
    schedule: 'Запланировать звонок',
    scheduleTitle: 'Запланировать звонок с {name}',
    subjectPlaceholder: 'Тема (необязательно)',
    priceNote: 'Тариф звонка: {price}',
    sendReservation: 'Отправить запрос на бронирование',
    reservationSent: 'Запрос отправлен',
    reservationSentBody: 'Запрос на бронирование звонка отправлен пользователю {name}.',
    reservationFailed: 'Не удалось отправить запрос на бронирование звонка',
    reservationBubble: '☎️ Запрошено бронирование звонка',
    reservationBubbleShort: '☎️ Бронирование звонка',
    reservationLabel: 'Бронирование голосового звонка',
    rescheduleBubble: '☎️ Предложено новое время звонка',
    rescheduleBubbleShort: '☎️ Новое время звонка',
  },
  wallet: {
    otherAmount: "Другая сумма",
    customAmount: "Сумма",
    customAmountHint: "До {amount}; не более двух знаков после запятой.",
    title: 'Кошелёк',
    failed: 'Не удалось загрузить кошелёк',
    availableBalance: 'Доступный баланс',
    earningsTitle: 'Мои доходы',
    earningsTotal: 'Всего заработано',
    earningsWithdrawable: 'Доступно для вывода',
    earningsEscrow: 'В резерве',
    addFunds: 'Пополнить',
    addFundsDemo: 'Демо: добавить тестовый баланс на счёт',
    addFundsFailed: 'Не удалось пополнить баланс.',
    topupLabel: 'Баланс пополнен',
    transactions: 'Транзакции',
    noTransactions: 'Пока нет транзакций',
    waiting: 'в ожидании',
    incomingRequest: 'входящий запрос',
    replied: 'отвечено',
    earned: 'заработано',
    refunded: 'Возвращено',
    requestPayout: 'Вывести',
    payoutHint: 'Можно вывести до {amount}.',
    payoutAll: 'Выбрать всю сумму',
    payoutRequested: 'Заявка принята',
    payoutRequestedBody: 'Заявка на вывод {amount} создана и будет обработана в ближайшее время.',
    payoutFailed: 'Не удалось создать заявку на вывод',
    payoutRequests: 'Заявки на вывод',
    noPayouts: 'Пока нет запросов на вывод',
    payoutStatusPending: 'В ожидании',
    payoutStatusPaid: 'Выплачено',
    payoutStatusRejected: 'Отклонено',
    paymentAccount: 'Платёжный аккаунт',
    stripeConnect: 'Подключить платёжный аккаунт',
    stripeConnectInfo: 'Привяжи банковский счёт, чтобы получать доход (Stripe, тестовый режим)',
    stripeConnected: 'Подключено',
    stripeConnectFailed: 'Не удалось подключиться',
  },
  calendar: {
    dateInputLabel: "Дата",
    timeInputLabel: "Время",
    dateInputHint: "Введи год, месяц и день в формате YYYY-MM-DD.",
    timeInputHint: "Введи время в 24-часовом формате HH:MM.",

    previousWeek: 'Предыдущая неделя',
    nextWeek: 'Следующая неделя',
    empty: 'Нет запросов для отображения',
    failed: 'Не удалось загрузить календарь',
    statusPending: 'Ожидание',
    statusAccepted: 'Принято',
    statusDeclined: 'Отклонено',
    statusCancelled: 'Отменено',
    statusExpired: 'Срок истёк',
    accept: 'Принять',
    decline: 'Отклонить',
    cancel: 'Отменить',
    cancelConfirmationTitle: 'Отменить бронирование?',
    cancelConfirmationAcceptedBody: 'Подтверждённое бронирование с {name} будет отменено. Другой участник получит уведомление. Это действие нельзя отменить.',
    cancelConfirmationPendingBody: 'Предложение, отправленное {name}, будет отозвано. Другой участник получит уведомление. Это действие нельзя отменить.',
    actionFailed: 'Не удалось выполнить действие',
    proposeTitle: 'Предложить встречу с {name}',
    locationPlaceholder: 'Где? (необязательно)',
    sendProposal: 'Отправить предложение',
    proposalSent: 'Предложение отправлено',
    proposalSentBody: 'Твоё предложение о встрече отправлено {name}.',
    priceChangedBody: 'Тариф за минуту для этой брони теперь {amount}. Предложение не создано — посмотри новый тариф и предложи снова.',
    proposalFailed: 'Не удалось отправить предложение',
    meetupBubble: '📅 Предложена встреча',
    meetupBubbleShort: '📅 Предложение о встрече',
    proposeAction: '📅 Предложить встречу',
    priceNote: 'Тариф встречи: {price}',
    totalCost: 'Итого: {amount}',
    minutesShort: 'мин',
    tabRequests: 'Запросы',
    tabCalendar: 'Календарь',
    tabActive: 'Текущие',
    tabHistory: 'История',
    loadMore: 'Показать ещё',
    noEventsForDay: 'В этот день событий нет',
    meetupLabel: 'Личная встреча',
    reservationDetails: 'Детали бронирования',
    reservationParticipant: 'Участник',
    reservationHeld: 'Звонок состоялся',
    reservationNotHeld: 'Звонок не состоялся',
    reservationDateTime: 'Дата и время',
    reservationDuration: 'Длительность',
    reservationRate: 'За минуту',
    reservationLocation: 'Место',
    reservationSubject: 'Тема',
    reservationQuotedTotal: 'Сумма предложения',
    reservationBilledDuration: 'Оплачиваемая длительность',
    reservationSpentAmount: 'Уплаченная сумма',
    reservationEarnedAmount: 'Полученная сумма',
    reservationSettledAt: 'Расчёт произведён',
    reservationCreated: 'Создано',
    reservationResponded: 'Получен ответ',
    reservationAcceptedAt: 'Принято',
    reservationDeclinedAt: 'Отклонено',
    reservationCancelledAt: 'Отменено',
    reservationCancelledBy: 'Кто отменил',
    reservationYou: 'Ты',
    reservationCancellationNotification: 'Отправка уведомления',
    reservationNotificationPending: 'Подготавливается',
    reservationNotificationProviderAccepted: 'Принято службой доставки',
    reservationNotificationSuppressed: 'Не отправлено из-за настроек уведомлений',
    reservationNotificationUnavailable: 'Подходящее устройство не найдено',
    reservationPendingReschedule: 'Предложенное новое время',
    reservationNewTime: 'Новая дата и время',
    proposeNewTime: 'Предложить новое время',
    rescheduleFuture: 'Новое время должно быть в будущем и отличаться от текущего времени начала бронирования не менее чем на одну минуту.',
    reservationCallTooEarly: 'Этот запланированный звонок станет доступен за 15 минут до начала.',
    reservationCallExpired: 'Окно звонка для этого бронирования завершилось.',
    reservationCallInProgress: 'Звонок, связанный с этим бронированием, уже начат.',
    reservationExecutionLocked: 'Этот запланированный звонок уже начался или завершился, поэтому изменить его нельзя.',
    openReservation: 'Открыть детали бронирования с {name}',
    systemEventMeetupTitle: 'Встреча с {name}',
    systemEventCallTitle: 'Запланированный звонок с {name}',
    systemEventNotes: 'Подтверждено через nosubject.',
    systemCalendarCopyRemoved: 'Копия в системном календаре удалена',
    restoreSystemCalendarCopy: 'Восстановить',
    systemCalendarRestoreFailed: 'Не удалось восстановить копию события в календаре. Проверь подключения календаря и системное разрешение.',
    systemCalendarCopyChanged: 'Время в системном календаре изменено',
    reviewSystemCalendarChange: 'Проверить',
    systemCalendarChangeTitle: 'Время события в календаре изменено',
    systemCalendarChangeBody: 'Это изменение не применено для другого человека.\n\nnosubject: {nosubject}\nСистемный календарь: {system}',
    restoreNosubjectTime: 'Вернуть время nosubject',
    systemCalendarTimeRestoreFailed: 'Не удалось исправить время копии события в календаре. Проверь подключения и системное разрешение.',
    proposeReschedule: 'Предложить другому участнику',
    rescheduleSent: 'Предложено новое время',
    rescheduleSentBody: 'Предложение нового времени отправлено пользователю {name}. Время бронирования не изменится, пока другой участник не примет предложение.',
    rescheduleFailed: 'Не удалось предложить новое время.',
    rescheduleActionFailed: 'Не удалось обновить предложение времени.',
    reschedulePendingReceived: 'Предложено новое время: {time}',
    reschedulePendingSent: 'Новое время ожидает ответа: {time}',
    withdrawReschedule: 'Отозвать предложение',
    rescheduleBubble: '📅 Предложено новое время встречи',
    rescheduleBubbleShort: '📅 Новое время встречи',
    connectionsTitle: 'Подключения календаря',
    connectionsInfo: 'Выбери календари для отображения',
    deviceCalendar: 'Календари устройства',
    connect: 'Подключить',
    openSettings: 'Открыть настройки',
    permissionGranted: 'Доступ разрешён',
    permissionDenied: 'Доступ отключён',
    permissionUnavailable: 'Недоступно в этой версии',
    permissionNotRequested: 'Ещё не подключено',
    devicePermissionInfo: 'Разрешение запрашивается только после нажатия этой кнопки. nosubject читает лишь выбранные календари и нужный период; события с этого экрана не записываются.',
    selectCalendars: 'Показываемые календари',
    noDeviceCalendars: 'На устройстве нет доступных календарей событий.',
    manageSystemPermission: 'Управлять системным разрешением',
    connectionPrivacyInfo: 'Выбор хранится на этом устройстве для этой учётной записи. Внешние сведения видны только тебе и не передаются автоматически.',
    newBuildRequired: 'Для подключения календарей нужна новая версия приложения.',
    connectionFailed: 'Не удалось подключить календарь.',
    disconnect: 'Отключить',
    disconnectTitle: 'Отключить календарь?',
    disconnectBody: 'nosubject перестанет читать календари и записывать новые подтверждённые события на этом устройстве. Выбор и локальные связи будут удалены; существующие события системного календаря останутся. Системное разрешение можно отдельно отозвать в настройках устройства.',
    disconnectFailed: 'Не удалось отключить календарь.',
    selectionSaveFailed: 'Не удалось сохранить выбор.',
    allDay: 'Весь день',
    recurring: 'Повторяется',
    availabilityFree: 'Свободно',
    availabilityBusy: 'Занято',
    availabilityTentative: 'Предварительно',
    availabilityUnavailable: 'Недоступно',
    untitledExternalEvent: 'Событие без названия',
    externalEventsFailed: 'Не удалось загрузить внешние события.',
    hideExternalEvent: 'Скрыть «{title}» из этого представления',
    hideExternalEventFailed: 'Не удалось скрыть событие.',
    restoreHiddenExternalEvents: 'Снова показать скрытые события',
    restoreHiddenExternalEventsFailed: 'Не удалось снова показать скрытые события.',
    hiddenExternalEventCount: 'На этом устройстве скрыто событий: {count}',
    checkIncompleteTitle: 'Проверка календаря не завершена',
    checkIncompleteBody: 'По крайней мере один источник календаря временно недоступен, поэтому мы не можем подтвердить, что это время полностью свободно. При желании можно продолжить.',
    conflictCheckIncomplete: 'Некоторые календари недоступны, поэтому возможны и другие пересечения.',
    conflictTitle: 'Конфликт в календаре',
    reservationUnavailable: 'Это время больше недоступно из-за другого подтверждённого бронирования.',
    reservationChanged: 'Это бронирование было изменено на другом экране или устройстве. Мы загрузили актуальную версию.',
    reservationPast: 'Нельзя принять бронирование, время начала которого уже прошло.',
    conflictBody: 'Это время пересекается с другим событием в твоём календаре. При желании можно продолжить.',
    tentativeConflictTitle: 'Предварительное событие в календаре',
    tentativeConflictBody: 'Событие в календаре на это время ещё не подтверждено. Проверь детали, прежде чем продолжить.',
    conflictMore: '• Другие события: {count}',
    continueAnyway: 'Всё равно продолжить',
    onlineCalendars: 'Онлайн-календари',
    googleCalendar: 'Google Календарь',
    providerConnected: 'Подключено',
    providerNotConnected: 'Не подключено',
    providerUnavailable: 'Официальное подключение готовится',
    googlePrivacyInfo: 'Синхронизируются только выбранные тобой календари. Названия и места шифруются в минимальном серверном кеше; описания, участники и ссылки на конференции не сохраняются. nosubject не может создавать, изменять или удалять события Google Календаря.',
    googleConnectionFailed: 'Не удалось начать подключение Google Календаря.',
    microsoftCalendar: 'Календарь Microsoft',
    microsoftInfo: 'nosubject читает только твою занятость (Calendars.Read). Он не может создавать, изменять или удалять события. Доступ отзывается в настройках учётной записи Microsoft; nosubject не может отозвать его сам.',
    microsoftConnectionFailed: 'Не удалось начать подключение календаря Microsoft.',
    googleDisconnectTitle: 'Отключить Google Календарь?',
    googleDisconnectBody: 'nosubject перестанет получать данные Google Календаря и отзовёт разрешения Google, которые ты предоставил nosubject. События в Google Календаре не удалятся.',
    googleDisconnectFailed: 'Не удалось отключить Google Календарь.',
    googleNoCalendars: 'Не найдено доступных для чтения календарей Google.',
    googleSelectionSaveFailed: 'Не удалось сохранить выбор календарей Google.',
  },
  instagram: {
    title: 'Подключение Instagram',
    connectInfo: 'Подключи профессиональный аккаунт с явным согласием',
    connectedAccounts: 'Подключённые аккаунты',
    professionalAccount: 'Профессиональный аккаунт',
    connect: 'Подключить',
    reconnect: 'Подключить заново',
    connectedAs: '@{username} · {accountType}',
    notConnected: 'Ещё не подключён',
    unavailable: 'Официальное подключение готовится',
    privacyInfo: 'На первом этапе запрашивается только instagram_business_basic для чтения данных профессионального аккаунта. Доступ к сообщениям, комментариям и публикации не запрашивается; фотографии не копируются в nosubject без отдельного выбора импорта.',
    business: 'Бизнес',
    creator: 'Автор',
    connectionFailed: 'Не удалось начать подключение Instagram.',
  },
  inbox: {
    markUnread: 'Отметить как непрочитанное',
    markRead: 'Отметить как прочитанное',
    archiveTitle: 'Архив',
    archive: 'Архив',
    failed: 'Не удалось загрузить переписки',
    searchEmpty: 'Нет результатов',
    archivedEmpty: 'Нет архивных переписок',
    empty: 'Пока нет переписок',
    you: 'Ты:',
    archived: 'В архиве',
    unarchived: 'Извлечено из архива',
    undo: 'Отменить',
    mute: 'Без звука',
    muteTitle: 'Отключить звук для {name}',
    mute1h: 'На 1 час',
    mute8h: 'На 8 часов',
    mute1w: 'На 1 неделю',
    muteForever: 'Пока не включу снова',
    unmute: 'Включить звук',
    archiveAction: 'В архив',
    unarchiveAction: 'Из архива',
    swipeRemove: 'Из архива',
    swipeArchive: 'В архив',
    blockAction: 'Заблокировать',
    blockTitle: 'Заблокировать {name}?',
    blockMessage: 'Этот человек не сможет писать тебе или найти тебя в поиске.',
    blockConfirm: 'Заблокировать',
  },
  // 9.33.9.3 / D-780 — passkeys, named as the system names them.
  passkeys: {
    // D-882 — signing in with a passkey.
    signIn: "Войти с ключом входа",
    signInIntro: "С ключом входа можно войти без номера телефона и кода.",
    signInNone: "На этом устройстве нет ключа входа для nosubject. Сначала войди по номеру телефона, а потом добавь ключ: Профиль → Настройки → Способы входа → Ключи входа.",
    signInFailed: "Не удалось войти с ключом входа. Попробуй ещё раз.",
    // D-876 — a lost passkey, reset after a 48-hour wait.
    lost: "Потерял ключ входа?",
    recoveryIntro: "Если ни на одном твоём устройстве больше нет ключа входа, его можно сбросить. После подтверждения номера нужно подождать 48 часов. Мы сообщим тебе об этом в чате, и тот, у кого есть твой ключ входа, может отменить сброс.",
    recoveryPending: "Сброс будет готов {date}.",
    recoveryCancel: "Отменить сброс",
    recoveryCancelled: "Сброс отменён.",
    recoveryReady: "Сброс готов. Добавь новый ключ входа.",
    recoveryDone: "Новый ключ входа добавлен. Старые больше не работают.",
    title: "Ключи входа",
    intro: "Ключ входа подтверждает, что это ты, так же как ты разблокируешь это устройство. Он остаётся на устройстве; nosubject никогда не получает твоё лицо или отпечаток пальца.",
    taskIntro: "Сообщения, которые ты отправляешь официальному аккаунту nosubject, перед отправкой подтверждаются ключом входа.",
    empty: "У тебя пока нет ключа входа.",
    add: "Добавить ключ входа",
    remove: "Удалить",
    removeTitle: "Удалить этот ключ входа?",
    removeBody: "Сначала ты подтвердишь это ключом входа.",
    added: "Ключ входа добавлен.",
    removed: "Ключ входа удалён.",
    addedOn: "Добавлен {date}",
    lastUsed: "Последнее использование: {date}",
    unnamed: "Ключ входа",
    reauthIntro: "Чтобы добавить первый ключ входа, подтверди свой зарегистрированный номер телефона.",
    sendCode: "Отправить код подтверждения",
    codeSent: "Код отправлен на зарегистрированный номер, оканчивающийся на {phone}.",
    codeLabel: "Код подтверждения",
    startAgain: "Начать заново",
    wrongCode: "Этот код не подошёл. Запроси новый.",
    failed: "Не удалось выполнить запрос. Попробуй ещё раз.",
    exists: "На этом устройстве уже есть ключ входа для твоего аккаунта.",
    unsupportedApp: "Эта версия приложения пока не умеет работать с ключами входа. Они появятся в следующем обновлении.",
    unsupportedWeb: "Этот браузер не поддерживает ключи входа.",
    tapTitle: "Продолжить с ключом входа",
    tapAction: "Продолжить",
  },
  message: {
    jumpLatest: 'К последнему сообщению',
    info: "Информация о сообщении",
    infoSentAt: "Отправлено",
    infoReadAt: "Прочитано",
    infoPlatform: "Платформа отправки",
    // 9.33.9.4 — a message to the task chat stopped for its passkey.
    passkeyNeededTitle: "Сначала добавь ключ входа",
    passkeyNeededBody: "Сообщения этому аккаунту подтверждаются ключом входа. Добавь его и отправь снова.",
    passkeyUnavailable: "Этому сообщению нужен твой ключ входа, а эта версия приложения пока не умеет с ним работать. Отправь его с nosubject.co или после следующего обновления.",
    passkeyFailed: "Сообщение не удалось подтвердить, поэтому оно не отправлено.",
    forwardOwn: "Переслать",
    forwardHint: "Выбери чат. Текст откроется как черновик; отправка и подтверждение текущей цены выполняются отдельно.",
    forwardMediaHint: "Выбери чат. Откроется отдельный черновик медиа: проверь цену и нажми «Отправить». Подпись и местоположение не копируются.",
    forwardMediaWaiting: "Подготовка ещё не подтверждена. Повторная попытка проверит ту же операцию, но не отправит сообщение.",
    forwardMediaUnavailable: "Не удалось подтвердить операцию. Проверь чат перед повторной отправкой.",
    forwardEmpty: "Других активных чатов нет.",
    forwardDraftFirst: "Сначала отправьте или очистите текущий черновик.",
    translationLanguage: "Язык перевода",
    chooseTranslationLanguage: "Выбери язык перевода",
    languageSuggestion: "Предложен язык устройства",
    translationLanguageInfo: "Эта личная настройка применяется к переводам во всех твоих чатах. Она не добавляется в профиль.",
    photoCaption: "Добавь подпись к фото…",
    removePhoto: "Убрать фото",
    star: "Отметить звёздочкой",
    unstar: "Убрать звёздочку",
    starred: "Избранные сообщения",
    noStars: "В этом чате нет избранных сообщений.",
    starFailed: "Не удалось обновить избранное. Повторите попытку.",
    starredAttachment: "Сообщение с вложением",
    edit: "Изменить сообщение",
    edited: "Изменено",
    editInfo: "Сообщение можно менять до прочтения, даже если уведомления о прочтении скрыты. Исчезновение кнопки изменения может выдать прочтение. Непрочитанное не значит невиденное: исходный текст мог появиться в уведомлении. Изменение не гарантирует, что слова можно взять обратно.",
    editFailed: "Не удалось подтвердить изменение. Сообщение могли прочитать или изменить. Проверь чат перед повторной попыткой.",
    copy: "Копировать",
    copyFailed: "Не удалось скопировать сообщение. Попробуй ещё раз.",
    inputPlaceholder: 'Напиши сообщение…',
    typing: 'Печатает',
    translate: 'Перевести',
    withdrawn: 'Сообщение отозвано',
    linkOpenTitle: 'Открыть ссылку',
    linkOpenBody: 'Ты перейдёшь на {host}. Ссылку прислал человек, который тебе пишет, — будь осторожен, если не знаешь его.',
    linkOpenConfirm: 'Открыть',
    linkOpenFailed: 'Не удалось открыть ссылку.',
    seenAt: 'Просмотрено {time}',

    priceChangedTitle: 'Цена изменилась',
    priceChangedBody: 'Это сообщение теперь стоит {new}, а не {old}. Всё равно отправить?',
    priceChangedSend: 'Отправить',
    priceNoticeTitle: 'Сколько стоит общение с этим человеком',
    priceNoticeMessage: '{amount} за сообщение',
    priceNoticeCall: 'Звонки {amount}',
    priceNoticePersonal: 'Эти тарифы установлены лично для тебя.',
    priceDecreasedTitle: "Цена сообщений снизилась",
    priceDecreasedBody: "Теперь сообщения стоят {new} вместо {old}. Подтверждать более низкую цену не нужно.",
    priceChange: {
      free: 'бесплатно',
    },
    expired: 'истекло, возврат средств',
    // 9.2 / D-650 — web'den gönderilen mesajın saat satırındaki notu.
    sentFromWeb: 'через веб',
    linkViewLabel: 'Вид ссылки',
    linkViewPlain: 'Обычный адрес',
    linkViewCompact: 'Кратко',
    linkViewCard: 'Большая карточка',
    linkPreviewLoading: 'Готовим превью…',
    linkPreviewFailed: 'Не удалось получить превью этой ссылки; она уйдёт обычным адресом.',
    linkPreviewA11y: 'Ссылка: {title}, {host}',
    customPrice: 'Особая цена',
    priceUsesGeneral: 'Действует моя общая цена',
    priceRemove: 'Убрать из контактов',
    priceRemoveTitle: 'Убрать {name} из контактов?',
    priceRemoveBody: 'Особая цена исчезнет, и для {name} снова будет действовать твоя общая цена. Если писать могут только контакты, новый разговор начать уже не выйдет. Это не блокировка.',
    priceRemoveConfirm: 'Убрать',
    priceRemoved: 'Для {name} снова действует общая цена.',
    pricePrompt: 'Цены для {name} (0 = бесплатно):',
    saved: 'Сохранено',
    priceFreeSet: '{name} теперь может писать тебе бесплатно.',
    priceSet: 'Цена для {name} установлена: {price}.',
    saveError: 'Не удалось сохранить.',
    photoError: 'Не удалось отправить фото.',
    noConnection: 'Нет соединения',
    checkInternet: 'Проверь подключение к интернету.',
    sendError: 'Не удалось отправить сообщение.',
    addAttachment: 'Добавить вложение',
    sendMessageAction: 'Отправить сообщение',
    lowBalanceTitle: 'Недостаточно средств',
    lowBalanceBody: 'Твой баланс меньше цены сообщения для этого человека. Пополни баланс и попробуй снова.',
    reply: 'Ответить',
    reactionA11y: 'Реакция {emoji}, всего {count}',
    reactionA11yMine: 'Реакция {emoji}, всего {count}, включая твою',
    reactionAdd: 'Отреагировать с помощью {emoji}',
    moreReactions: 'Другие эмодзи',
    reactionRemove: 'Убрать свою реакцию {emoji}',
    you: 'Ты',
    photo: '📷 Фото',
    takePhoto: 'Сделать фото',
    choosePhoto: 'Выбрать из галереи',
    chooseVideo: 'Выбрать видео',
    recordVoice: 'Голосовое сообщение',
    micPermissionTitle: 'Нужен доступ к микрофону',
    micPermissionBody: 'Для записи голосового сообщения нужен доступ к микрофону.',
    voiceError: 'Не удалось отправить голосовое сообщение',
    voiceRecording: 'Идёт запись',
    videoTooLarge: 'Видео слишком большое (максимум 1 ГБ)',
    videoTooLong: 'Видео слишком длинное (максимум 10 минут)',
    videoError: 'Не удалось отправить видео',
    videoNeedsUpdate: 'Обнови приложение, чтобы посмотреть это видео',
    voiceNeedsUpdate: 'Обнови приложение, чтобы послушать это голосовое сообщение',
    voiceOrderTitle: 'Голосовое сообщение заказано',
    encrypted: 'Зашифрованное сообщение',
    identityChanged: 'Ключ безопасности этого человека изменился. Обычно это значит новый телефон или переустановленное приложение.',
    identityChangedVerify: 'Этот чат был подтверждён; сравни код безопасности снова.',
    unencrypted: 'Этот чат не зашифрован',
    unencryptedPeerInfo: 'Приложение собеседника пока не поддерживает сквозное шифрование, поэтому то, что ты пишешь здесь, отправляется без шифрования и может быть прочитано на сервере nosubject. Когда собеседник обновит приложение, новые сообщения будут шифроваться автоматически.',
    unencryptedOfficialInfo: 'Это официальный аккаунт nosubject. То, что ты пишешь здесь, отправляется без шифрования, и команда nosubject может это прочитать.',
    unencryptedSelfInfo: 'На этом устройстве не удалось включить шифрование (например, приватное окно браузера не может хранить ключи). То, что ты отправляешь отсюда, не зашифровано и может быть прочитано на сервере nosubject.',
    notificationOfferEnable: 'Включить уведомления',
    notificationOfferEnabled: 'Уведомления включены',
    voiceOrderPending: 'Ждём доставку',
    voiceOrderDelivered: 'Доставлено',
    voiceOrderDeclined: 'Отклонено, возвращено',
    voiceOrderExpired: 'Срок истёк, возвращено',
    voiceOrderAction: 'Заказать голосовое',
    voiceOrderPick: 'Какой длины запись?',
    voiceOrderInsufficient: 'На этот заказ не хватает баланса.',
    voiceOrderError: 'Не удалось оформить заказ.',
    voiceOrderRecord: 'Записать и отправить',
    voiceOrderDecline: 'Отклонить',
    voiceOrderDeclineTitle: 'Отклонить заказ',
    voiceOrderDeclineBody: 'Вся зарезервированная сумма вернётся тому, кто заказал.',
    voiceOrderDeclineError: 'Не удалось отклонить заказ.',
    voiceOrderDeliverError: 'Не удалось доставить запись.',
    voiceOrderRecording: 'Заказанная запись',
    voiceOrderRemaining: 'Осталось {length}',
    voiceOrderShortNote: 'Отправишь короче — оплатят только то, что записал.',
    voiceOrderRefunded: 'Возвращено {amount}',
    sendLocation: 'Отправить геопозицию',
    locationTitle: 'Геопозиция',
    locationError: 'Не удалось отправить геопозицию',
    shareLiveLocation: 'Поделиться геопозицией',
    liveLocationHour: '1 час',
    liveLocationEightHours: '8 часов',
    liveLocationOpenEnded: 'Пока не остановлю',
    liveLocationSharing: 'Твоя геопозиция передаётся',
    liveLocationStop: 'Остановить',
    liveLocationError: 'Не удалось начать передачу геопозиции',
    liveLocationCardTitle: 'Геопозиция',
    liveLocationCardActive: 'Передаётся сейчас',
    liveLocationCardEnded: 'Передача завершена',
    liveLocationOpen: 'Посмотреть геопозицию',
    liveLocationNoPoint: 'Позиции пока нет',
    liveLocationOpenInMaps: 'Открыть в Картах',
    locationMapError: 'Не удалось открыть карту.',
    liveLocationUpdatedAgo: 'Обновлено {ago}',
    videoShort: '🎬 Видео',
    voiceShort: '🎙 Голосовое сообщение',
    liveLocationWatchedAgo: 'Смотрели {ago} назад',
    liveLocationNotWatched: 'Ещё не смотрели',
    liveLocationSharerSeesYou: 'Он видит, когда ты смотришь',
    cameraPermissionTitle: 'Нужен доступ к камере',
    cameraPermissionBody: 'Разреши доступ к камере, чтобы сделать фото.',
    cameraError: 'Не удалось открыть камеру.',
    photoLocationTitle: 'Место съёмки',
    photoLocationPromptFile: 'Место «{place}» получено из файла фотографии. Показывать его вместе с фото?',
    photoLocationPromptCapture: 'По местоположению устройства определено место «{place}». Показывать его вместе с фото?',
    photoLocationHide: 'Отправить без места',
    photoLocationShare: 'Отправить с местом',
    photoLocationFromFile: 'Получено из файла',
    photoLocationFromCapture: 'Местоположение устройства',
    photoLocationHideAfter: 'Скрыть место',
    photoLocationShowAfter: 'Показать место',
    photoLocationUpdateError: 'Не удалось обновить место съёмки.',
  },
  versionNotice: {
    title: 'Доступна новая версия',
    body: 'Обнови приложение, чтобы получить исправления безопасности и новые функции.',
    update: 'Обновить',
  },
  notifications: {
    title: 'Уведомления',
    cardBody: 'Включи уведомления устройства, чтобы не пропустить новые сообщения и ответы.',
    notNow: 'Не сейчас',
    enable: 'Включить уведомления',
    device: 'Уведомления устройства',
    stateOn: 'Включены · Управлять в настройках',
    stateOff: 'Выключены · Включить в настройках',
    stateAsk: 'Запрос ещё не показывался',
    preferences: 'Настройки уведомлений',
    preferencesInfo: 'Управление категориями, предпросмотром и разрешением устройства',
    stateUnsupported: 'Не поддерживается на этом устройстве',
    master: 'Все уведомления',
    masterInfo: 'Если выключить, все push-уведомления перестанут приходить. Настройки категорий сохранятся',
    categories: 'Категории',
    categoryEnabled: 'Уведомления этой категории',
    categoryEnabledInfo: 'Если выключить, push-уведомления этой категории перестанут приходить. Выбранные настройки сохранятся',
    events: 'События',
    messages: 'Сообщения',
    messagesInfo: 'Новые сообщения и ответы',
    meetups: 'Встречи',
    meetupsInfo: 'Предложения, изменения и результаты',
    meetupRequests: 'Новые предложения о встрече',
    meetupRequestsInfo: 'Когда тебе предлагают новую встречу',
    meetupUpdates: 'Ответы и отмены',
    meetupUpdatesInfo: 'Когда встречу принимают, отклоняют или отменяют',
    meetupReminders: 'Напоминания о встречах',
    meetupRemindersInfo: 'Когда приближается подтверждённая встреча',
    calls: 'Звонки',
    callsInfo: 'Входящие, запланированные и пропущенные звонки',
    incomingCalls: 'Входящие звонки',
    incomingCallsInfo: 'Звуковое уведомление, когда тебе звонят',
    callRequests: 'Предложения запланированного звонка',
    callRequestsInfo: 'Когда предложение создают, принимают, отклоняют или отменяют',
    callReminders: 'Напоминания о запланированных звонках',
    callRemindersInfo: 'Когда приближается подтверждённый запланированный звонок',
    missedCalls: 'Пропущенные звонки',
    missedCallsInfo: 'Когда звонок остался без ответа',
    financial: 'Деньги и эскроу',
    financialInfo: 'Изменения статуса транзакций',
    financialEarnings: 'Доход и эскроу',
    financialEarningsInfo: 'Когда эскроу освобождён или доход доступен',
    financialRefunds: 'Возвраты и истечение срока',
    financialRefundsInfo: 'Когда платёж возвращён или срок эскроу истёк',
    financialPayouts: 'Результаты вывода',
    financialPayoutsInfo: 'Когда запрос на вывод выполнен или отклонён',
    reactions: 'Эмодзи-реакции',
    reactionsInfo: 'Реакции на твои сообщения',
    official: 'От Nosubject',
    officialInfo: 'Объявления Nosubject о версиях, безопасности и твоём аккаунте. Не зависит от других уведомлений: если выключить, Nosubject не будет присылать уведомления, но сообщения всё равно придут во входящие.',
    preview: 'Предпросмотр сообщения',
    previewHidden: 'Скрыто',
    previewHiddenInfo: 'Не показывать отправителя и сообщение',
    previewSender: 'Только отправитель',
    previewSenderInfo: 'Показывать отправителя, скрывать сообщение',
    previewText: 'Отправитель и сообщение',
    previewTextInfo: 'Показывать до 80 символов',
    deviceInfo: 'Системное разрешение действует только на этом устройстве',
    openSettings: 'Открыть настройки',
    centerTitle: 'Центр уведомлений',
    centerMarkAll: 'Отметить всё прочитанным', centerMarkedAll: 'Всё отмечено прочитанным',
    centerEmpty: 'Уведомлений пока нет.',
    centerFailed: 'Не удалось загрузить уведомления.',
    centerMarkAllFailed: 'Не удалось отметить уведомления прочитанными.',
    centerUnknownPerson: 'Кто-то',
    centerEscrowExpiredRefunded: 'Срок эскроу истёк · платёж возвращён',
    centerEscrowReleasedEarning: 'Ответ отправлен · заработок зачислен',
    centerMeetupRequest: '{name} предложил(а) тебе встречу',
    centerCallRequest: '{name} предложил(а) запланированный звонок',
    centerCallReminder: '{name} · Скоро запланированный звонок',
    centerCallStarting: '{name} · Запланированный звонок начинается',
    centerMeetupStarting: '{name} · Встреча начинается',
    centerMeetupReminder: '{name} · Скоро встреча',
    centerMeetupUpdate: '{name} · Бронирование встречи: {status}',
    centerCallUpdate: '{name} · Бронирование звонка: {status}',
    centerMeetupRescheduleRequest: '{name} предложил(а) новое время встречи',
    centerCallRescheduleRequest: '{name} предложил(а) новое время звонка',
    centerMeetupRescheduleUpdate: '{name} · Новое время встречи: {status}',
    centerCallRescheduleUpdate: '{name} · Новое время звонка: {status}',
    centerBell: 'Центр уведомлений',
    centerBellUnread: 'Центр уведомлений, непрочитанных: {count}',
  },
  profile: {
    viewPhoto: "Открыть фото профиля",
    photoUnavailable: "Не удалось загрузить фото.",
    // 9.35.3 · D-830 — profile photos and videos.
    photos: "Фото",
    mediaPhotoLabel: "Фото {n} из {total}",
    mediaVideoLabel: "Видео {n} из {total}",
    mediaUnavailable: "Не удалось загрузить фото",
    mediaMore: "Показать ещё",
    // 9.35.4 · D-830 — removing one's own photo or video.
    mediaRemove: "Убрать из профиля",
    mediaRemovePhotoTitle: "Убрать это фото из профиля?",
    mediaRemoveVideoTitle: "Убрать это видео из профиля?",
    mediaRemoveBody: "Файл удаляется, его нельзя восстановить.",
    mediaRemoveFailed: "Не получилось убрать. Попробуй ещё раз.",
    webVisibility: 'Кто может видеть мою веб-страницу',
    webVisibilityLink: 'По ссылке',
    webVisibilityInfo: 'Твой профиль для тех, у кого нет аккаунта: страница nosubject.co/твоё-имя. Все: страница может появляться и в поисковиках. По ссылке: открыть её может тот, у кого есть адрес; поисковики её не показывают. В обоих случаях люди без аккаунта могут получить данные твоего профиля, включая время последнего посещения. Никто: никто без аккаунта не увидит твой профиль; страница пишет «Этот профиль недоступен». Твой профиль в приложении не меняется. Исчезновение из результатов поиска может занять несколько дней.',
    linkViewInfo: 'Выбери, как отправляется ссылка, которую ты пишешь. Для вариантов Кратко и Большая карточка телефон один раз открывает страницу и отправляет превью вместе с сообщением; сайт видит IP-адрес твоего телефона. В зашифрованном чате превью находится внутри шифрования; в незашифрованном чате nosubject видит ссылку и превью. Обычный адрес не открывает никаких страниц. Ссылки, отправленные из веба, всегда уходят обычным адресом.',
    linkViewAsk: 'Показывать варианты при наборе',
    linkViewAskInfo: 'Если включено, при наборе ссылки появляются два других вида, и можно выбрать один для этого сообщения. Если выключено, ссылки всегда уходят в виде, выбранном здесь.',
    whoCanCallInfo: 'Выбери, кто может тебе звонить; это действует для каждого звонка. Мои контакты — это люди, которым ты назначил личную цену. В разделе Исключения можно разрешить или запретить отдельным людям.',
    whoCanMessageInfo: 'Выбери, кто может начать с тобой новую переписку; уже начатые переписки не меняются. Мои контакты — это люди, которым ты назначил личную цену. В разделе Исключения можно разрешить или запретить отдельным людям.',
    readReceiptsInfo: "Уведомления о прочтении видны, только если оба их включили. Даже при отключении исчезновение кнопки изменения может выдать прочтение.",
    showTypingInfo: 'Если включено, собеседник видит, что ты печатаешь. Если выключить, этого не видит никто, а ты по-прежнему видишь, когда печатают другие.',
    officialAccount: 'Официальный аккаунт',
    information: 'Информация профиля',
    logout: 'Выйти',
    account: 'Аккаунт',
    accountData: 'Аккаунт и данные',
    name: 'Имя',
    surname: 'Фамилия',
    username: 'Имя пользователя',
    usernamePlaceholder: 'имяпользователя',
    usernameChecking: 'Проверка…',
    usernameAvailable: 'Доступно',
    usernameTaken: 'Это имя пользователя уже занято',
    usernameInvalid: '3–20 символов; первый — A–Z или a–z. Допустимы только A–Z, a–z, 0–9 и _.',
    usernameAdd: 'Добавить имя пользователя',
    profession: 'Профессия',
    professionNone: 'Профессия не добавлена',
    professionAdd: 'Добавить профессию',
    employer: 'Компания',
    employerPlaceholder: 'имякомпании',
    employerInfo: 'Укажи существующее имя пользователя nosubject. Эта отметка не означает, что место работы подтверждено.',
    employerNotFound: 'Активный аккаунт с таким именем пользователя не найден.',
    employerSelf: 'Нельзя указать собственный аккаунт как компанию.',
    bio: 'Расскажи о себе…',
    prices: 'Цены',
    settings: 'Настройки',
    priceMessage: 'Сообщение',
    priceVoice: 'Голосовое сообщение (за минуту)',
    priceVoiceShort: 'Голосовое сообщение',
    priceCall: 'Позвонить сейчас (за минуту)',
    priceCallShort: 'Позвонить сейчас',
    priceScheduledCall: 'Запланировать звонок (за минуту)',
    priceScheduledCallShort: 'Запланировать звонок',
    priceVideoCall: 'Видеозвонок',
    priceVideoCallShort: 'Видео',
    priceTime: 'Встреча (за минуту)',
    priceTimeShort: 'Встреча',
    currency: 'Валюта',
    saving: 'Сохранение…',
    wallet: 'Кошелёк',
    chatBackup: 'Резервная копия чатов',
    privacy: 'Конфиденциальность',
    readReceipts: 'Уведомления о прочтении',
    showTyping: 'Индикатор набора',
    keepArchived: 'Оставлять в архиве',
    keepArchivedInfo: 'Если выключено, новое сообщение вернёт переписку из архива',
    whoCanMessage: 'Кто может мне писать',
    whoCanCall: 'Кто может мне звонить',
    messagesFromContact: 'Сообщения от этого человека',
    callsFromContact: 'Звонки от этого человека',
    callExceptions: 'Исключения',
    callExceptionsEmpty: 'Исключений пока нет',
    messageExceptionsEmpty: 'Исключений для сообщений пока нет',
    exceptionsLoadFailed: 'Не удалось загрузить исключения',
    openProfileHint: 'Открывает профиль этого человека',
    callExceptionBlocked: 'Заблокирован',
    callsFromContactDefault: 'По умолчанию',
    callsFromContactAllow: 'Всегда разрешать',
    callsFromContactBlock: 'Никогда',
    everyone: 'Все',
    contacts: 'Мои контакты',
    nobody: 'Никто',
    blockedUsers: 'Заблокированные пользователи',
    blockedEmpty: 'Ты никого не заблокировал(а)',
    unblock: 'Разблокировать',
    appearance: 'Внешний вид',
    light: 'Светлая',
    dark: 'Тёмная',
    system: 'Системная',
    displayLanguage: 'Язык приложения',
    education: 'Университет',
    educationAdd: 'Добавить университет',
    educationNone: 'Университет не добавлен',
    educationLevel: 'Уровень',
    searchLanguage: 'Поиск языка…',
    photoChange: 'Изменить',
    saveFailed: 'Не удалось сохранить.',
    photoFailed: 'Не удалось загрузить фото.',
    photoChanged: "Фото изменено другой операцией или срок повторной попытки истёк. Выбери фото ещё раз.",
    deleteAccount: 'Удалить аккаунт',
    deleteTitle: 'Удалить аккаунт',
    deleteMessage: 'Твой аккаунт будет окончательно удалён через 30 дней. В течение этого времени ты можешь снова войти, чтобы отменить удаление.',
    deleteMoneyWarning: 'У тебя есть {amount} в кошельке и в резерве. Рекомендуем вывести средства перед удалением.',
    deleteConfirm: 'Удалить',
    deleteFailed: 'Не удалось удалить аккаунт.',
    deletionScheduled: 'Твой аккаунт будет удалён {date}.',
    deletionCancel: 'Отменить удаление аккаунта',
    exportData: 'Скачать мои данные',
    exportFailed: 'Не удалось получить данные.',
  },
  // Alt bar (dock) — ekran okuyucu etiketleri ve rozet sayıları (9.26.7.2.1)
  dock: {
    calls: 'Звонки',
    discover: 'Обзор',
    inbox: 'Сообщения',
    calendar: 'Календарь',
    profile: 'Профиль',
    unreadMessages: 'непрочитанных: {count}',
    pendingRequests: 'ожидают: {count}',
  },
  // 9.18.10.4 · D-830 — importing one's own Instagram download.
  instagramImport: {
    title: "Импорт из Instagram",
    addEntry: "Импорт из Instagram",
    guideIntro: "Скачай свои данные Instagram и выбери файл здесь, чтобы добавить свои фото и видео в профиль.",
    guideStep1: "В Instagram открой Центр аккаунтов → Твоя информация и разрешения → Скачать информацию.",
    guideStep2: "В разделе «Часть информации» отметь только «Контент»; формат JSON, качество медиа высокое.",
    guideStep3: "Когда Meta подготовит файл, скачай его и выбери здесь.",
    guideOwnOnly: "Показываются только фото и видео, которые ты публиковал; медиа из сообщений не берутся.",
    guideOnDevice: "Файл открывается на твоём устройстве и не отправляется на наш сервер; загружается только выбранное.",
    choose: "Выбрать ZIP-файл",
    reading: "Чтение архива",
    notZip: "Это не ZIP-архив.",
    untrusted: "Архив выглядит небезопасным, поэтому он не открыт.",
    tooBig: "Архив слишком большой.",
    unreadable: "Не удалось прочитать архив.",
    chooseAnother: "Выбрать другой файл",
    noMedia: "В архиве нет фото или видео, которые можно добавить.",
    found: "Найдено: {count}",
    slotsLeft: "Свободно мест в профиле: {count}",
    selectAll: "Выбрать всё",
    selectNone: "Снять выбор",
    alreadyOnProfile: "В профиле",
    tooLarge: "Слишком большой",
    add: "Добавить: {count}",
    adding: "Добавляется {n} из {total}",
    stop: "Остановить",
    stopping: "Остановка после этого",
    doneAdded: "Добавлено: {count}",
    doneDuplicate: "Уже в профиле: {count}",
    doneSkipped: "Пропущено: {count}",
    doneFailed: "Не добавлено: {count}",
    retryFailed: "Попробовать остальные снова",
    profileFull: "Профиль заполнен, больше добавить нельзя.",
    guideParts: "Если Meta разделила скачанный архив на несколько ZIP-частей, выбери их все сразу.",
    catAll: "Все",
    catPosts: "Публикации",
    catReels: "Reels",
    catStories: "Истории",
    catIgtv: "IGTV",
    catArchived: "Архив",
    catProfile: "Фото профиля",
    catOther: "Другое",
    archiveSection: "Скачанные данные Instagram",
    archiveHint: "Добавляет в профиль фото и видео из твоего собственного архива данных.",
  },
};
